package com.advaita.cloud.drive.shared

import kotlinx.serialization.Serializable

/** Compact per-file pipeline progress folded onto [FileDto] for the file listing. */
@Serializable
data class PipelineProgressDto(
    val pct: Int? = null,
    val phase: String? = null,
    val moduleWarn: Int = 0,
    val moduleFail: Int = 0,
    val error: String? = null,
)
